import * as React from 'react'
import { compose } from 'react-apollo'
import { ApolloError } from 'apollo-client'
import { RouteComponentProps } from 'react-router'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { History, Location } from 'history'

import {
  NewProjectDialog,
  Tabulations,
  tabType,
  ProjectDetails,
  CaseList
} from './'

import {
  SpinnerDiv,
  NormalMain,
  MainHeader,
  ProjectTools,
  ProjectWorkArea,
  ToolTitle,
  NormalButton,
  ViewSection,
  EmbeddedLink
} from './Styles'

import { withProject, ProjectType } from './projectQueries'
import { Store } from '../../reducers'
import { Action } from '../../actions/types'
import { setTabulationLock } from '../../actions/tabulation'
import Error from '../Shared/Alerts/Error'

type UrlParams = {
  projectId: string
}

type InputProps = {
  loading: boolean
  error?: ApolloError
  project?: ProjectType

  history: History
  location: Location
  tabulationLocked: boolean
  setTabLock: (lock: boolean) => Action
  test: string
}

type State = {
  newProject: boolean
  error: string | undefined
}

const tabs: tabType[] = [
  {
    name: 'PROJECT OVERVIEW',
    hash: '#info',
    view: project => <ProjectDetails project={project} />
  },
  {
    name: 'CASES',
    hash: '#cases',
    view: project => <CaseList cases={project.cases} />
  }
]

type WrappedProps = ProjectType & InputProps & RouteComponentProps<UrlParams>

class ProjectView extends React.Component<WrappedProps, State> {
  constructor(props: WrappedProps) {
    super(props)
    this.state = { newProject: false, error: undefined }
  }

  componentDidMount() {
    if (!this.props.loading && this.props.error) {
      this.setState({ error: this.props.error.message })
    }
  }

  componentWillUnmount() {
    this.props.setTabLock(false)
  }

  render() {
    const { loading, project, history, tabulationLocked } = this.props

    return (
      <NormalMain className={'page-main'}>
        <SpinnerDiv>
          {loading && <div className="spinner" />}
          {this.state.error && (
            <Error onDismiss={() => this.setState({ error: undefined })}>
              {this.state.error}
            </Error>
          )}
          <ProjectTools>
            <div
              style={{
                marginTop: '-25px',
                position: 'absolute',
                cursor: 'pointer'
              }}
              onClick={() => history.goBack()}
            >
              <span>{'<'}</span>
              <span style={{ paddingLeft: '10px' }}>Back</span>
            </div>
            <MainHeader>Project manager</MainHeader>
            <NormalButton
              type={'button'}
              onClick={() => this.setState({ newProject: true })}
              disabled={tabulationLocked}
            >
              + Create new project
            </NormalButton>
          </ProjectTools>
          <ViewSection key={'MyProjects'}>
            <ToolTitle>
              <EmbeddedLink onClick={() => history.goBack()}>
                My projects
              </EmbeddedLink>
              {'> ' + (project ? project.name : '')}
            </ToolTitle>
            <ProjectWorkArea>
              <Tabulations tabs={tabs} payload={project} />
            </ProjectWorkArea>
          </ViewSection>
          <NewProjectDialog
            isOpen={this.state.newProject}
            closeDialog={() => this.setState({ newProject: false })}
          />
        </SpinnerDiv>
      </NormalMain>
    )
  }
}

const mapStateToProps = (
  state: Store.Complete,
  ownProps: RouteComponentProps<UrlParams>
) => ({
  projectId: ownProps.match.params.projectId,
  tabulationLocked: state.tabulation.locked
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  setTabLock: lock => dispatch(setTabulationLock(lock))
})

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withProject
)(ProjectView)



// WEBPACK FOOTER //
// ./src/Components/Projects/ProjectView.tsx